import BaseMessageHandler from 'messages/BaseMessageHandler';
import { saveDataState } from 'actions/getData';

export default class Balance_Get extends BaseMessageHandler {
  success = () => {
    const {
      dispatch,
      message: { payload },
    } = this;

    dispatch(saveDataState('balances', {
      items: payload,
    }));
  };
}
